"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import s from "underscore.string";
import React from "react";
import _ from "underscore";
import $ from "jquery";
import ActivityStreamHelper from "../helpers/activity_stream";
import Api from "../api/api";
import ApiService from "../services/api_service";
import Blocker from "./blocker";
import "../helpers/carrier";
import CarrierService from "../services/carrier_service";
import CarrierInvoiceHelper from "./../helpers/carrier_invoice";
import CloseReply from "./close_reply";
import DataStoreService from "./data_store_service";
import DashboardReturnParams from "./ui/dashboard_return_params";
import DocumentBrowser from "./react_document_browser";
import DocumentIndexerService from "./document_indexer_service";
import DocumentsService from "./documents_service";
import DocumentInformation from "./indexer/document_information";
import "./indexer/document_types_setter";
import EmailHelper from "../helpers/email_message";
import "./indexer/email_viewer";
import ExceptionSender from "./exception_sender";
import FactorInvoicesService from "./factor_invoices_service";
import "../util/fetch";
import IndexerHeader from "./indexer/indexer_header";
import LoadDetailInformation from "./indexer/load_detail_information";
import LoadsService from "./loads_service";
import MarkEmailCompleteView from "./mark_email_complete_view";
import moment from "moment";
import PaymentInformation from "./indexer/payment_information";
import PresenceList from "./presence";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
import WaitingSpinner from "../components/waiting_spinner";
import { EmailForwarder } from "./email_forwarder";
import { emailService } from "../services/email_service";
import {
  GroupedDocumentBrowserModel,
  GroupIDGroupCreator,
  DocumentBatchGroupCreator
} from "./grouped_document_browser_model";
import {
  addToIgnoredItems,
  maybePrefetchNextFlowModeItem,
  isInNewFlowMode
} from "./flow_mode/flow_mode_service";
import { isAuditMode } from "./index_audit_split_mode";
import { push } from "./app_history";
function quotedBody(email) {
  var prefix = "\n\n\nat " + moment(email.created_at).format("LLL") + email.sender_address + " wrote:\n";
  return prefix + _.map(s.lines(email.text_body), function(line) {
    return "> " + line;
  }).join("\n");
}
function exceptionedItems(state) {
  return state.email.parent.exceptioned_items || [];
}
function carrierInvoice(state) {
  if (state.load) {
    return state.load.carrier_invoices.find((ci) => {
      const invoiceEmails = ci.email_messages || ci.emails || [];
      return invoiceEmails.some((e) => e.id == state.email.id);
    }) || state.load.carrier_invoices[0];
  }
}
function carrier(state) {
  return CarrierService.getCarrierOrUnknown(carrierInvoice(state).carrier_id);
}
function payment(state) {
  const result = {};
  const invoice = carrierInvoice(state);
  result.payOn = invoice.date_to_pay || CarrierInvoiceHelper.paymentDueOn(invoice);
  result.amount = invoice.amount_to_pay || invoice.source_invoice_amount;
  return result;
}
function initialSelectedComponent(state) {
  if (possibleMessageBrowserComponent(state)) {
    return "Messages";
  }
}
function possibleMessageBrowserComponent(state) {
  const invoice = state.factorInvoice || carrierInvoice(state);
  const email = state.email;
  let emails;
  if (invoice) {
    emails = invoice.email_messages || invoice.emails || [];
  } else {
    if (email) {
      emails = _.sortBy([email].concat(email.parent_emails), "created_at").reverse() || [];
    }
  }
  if (emails) {
    if (emails.length > 0) {
      return {
        label: "Messages",
        component: EmailHelper.emailMessages(emails)
      };
    }
  }
}
function additionalBrowserComponents(state) {
  return _.compact([
    possibleMessageBrowserComponent(state),
    activityBrowserComponent(state)
  ]);
}
function activityBrowserComponent(state) {
  return {
    label: "Activity",
    component: ActivityStreamHelper.invoiceActivity(
      invoiceActivityItems(state)
    )
  };
}
function invoiceActivityItems(state) {
  if (state.factorInvoice) {
    return state.factorInvoice.activity_items || [];
  } else {
    return [];
  }
}
function hasDocuments(state) {
  return state.newDocumentsModel;
}
function emailInstructions(state) {
  if (!state.sendingEmail) {
    if (state.newDocumentBatch) {
      return /* @__PURE__ */ jsx("div", { className: "alert-box--progress", children: "Review the email for this load. When done, you can view the original email or process the new documents to continue." });
    } else {
      return /* @__PURE__ */ jsx("div", { className: "alert-box--progress", children: "Review the email for this load. When finished you can respond or view the original email to continue." });
    }
  }
}
function emailChainWithoutDocuments(state) {
  return !state.originalDocumentBatchId && !state.newDocumentBatch;
}
function carrierInvoiceApproved(state) {
  return carrierInvoice(state) && carrierInvoice(state).state === "approved";
}
function goToLoad(props, state) {
  push("/loads/" + state.load.id, {
    fromReply: true,
    emailMessageId: state.email.id,
    onDone: props.location.query.onDone,
    filters: props.location.query.filters
  });
}
function doneMarkingComplete(props) {
  ToDashboardWithFilters(props.location);
}
function goToNewDocumentsBatch(props, state) {
  push(
    "/index-document-batches/" + state.newDocumentBatch.id,
    DashboardReturnParams(props.location)
  );
}
function processOriginalDocuments(props, state) {
  const dashboardParams = _.tap(
    DashboardReturnParams(props.location),
    (params) => {
      if (state.originalDocumentGroupId) {
        params["group_id"] = state.originalDocumentGroupId;
      }
    }
  );
  push(
    "/index-document-batches/" + state.originalDocumentBatchId,
    dashboardParams
  );
}
function goToFactorInvoice(props, state) {
  push("/factor_invoices/" + state.factorInvoice.id, {
    emailId: state.email.id,
    onDone: props.location.query.onDone,
    filters: props.location.query.filters
  });
}
function skipReply(props, state) {
  addToIgnoredItems("email_ids", state.email.id);
  ToDashboardWithFilters(props.location);
}
function possibleProcessNewDocumentsButton(props, state) {
  if (state.newDocumentBatch) {
    return /* @__PURE__ */ jsx(
      "button",
      {
        className: "button--progress",
        onClick: () => goToNewDocumentsBatch(props, state),
        children: "Process New Documents"
      }
    );
  }
}
function onComplete(props) {
  ToDashboardWithFilters(props.location);
}
function possibleProcessFactorInvoiceButton(props, state) {
  if (state.factorInvoice) {
    return /* @__PURE__ */ jsx(
      "button",
      {
        className: "button--progress",
        onClick: () => goToFactorInvoice(props, state),
        children: "Process Documents"
      }
    );
  }
}
function processOriginalButton(props, state) {
  if (state.originalDocumentBatchId) {
    return processOriginalDocumentsButton(props, state);
  }
}
function processOriginalDocumentsButton(props, state) {
  return /* @__PURE__ */ jsx(
    "button",
    {
      className: "button--progress",
      onClick: () => processOriginalDocuments(props, state),
      children: "Process Original Documents"
    }
  );
}
function possibleCloseReplyLink(props, state) {
  if (carrierInvoiceApproved(state)) {
    return /* @__PURE__ */ jsx(
      CloseReply,
      {
        emailId: state.email.id,
        onComplete: () => doneMarkingComplete(props)
      }
    );
  }
}
function goToIndexer(props, state) {
  if (state.newDocumentBatch) {
    const docs = state.newDocumentBatch.documents;
    if (_.every(docs, (doc) => {
      return doc.type;
    })) {
      goToLoad(props, state);
    } else {
      goToNewDocumentsBatch(props, state);
    }
  } else {
    goToLoad(props, state);
  }
}
function addDocumentsToInvoiceAndGoToIndexer(props, state) {
  if (state.newDocumentsModel) {
    var docs = state.newDocumentsModel.activeDocuments();
    var carrierId = state.email.document_batch_carrier_id;
    ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.ajax({
        url: "/api/documents/assign_documents_to_new_or_existing_invoice",
        data: {
          load_state_id: state.load.id,
          carrier_invoice_id: carrierInvoice(state).id,
          carrier_id: carrierId,
          document_ids: _.pluck(docs, "id")
        },
        method: "post"
      }).then((result) => {
        DataStoreService.updateStores(result);
        goToIndexer(props, state);
      }),
      null,
      { caller: "ReplyView.addDocumentsToInvoiceAndGoToIndexer" }
    );
  } else {
    goToIndexer(props, state);
  }
}
function loadContinueLink(props, state) {
  const buttonText = hasDocuments(state) ? "Process Documents" : "Continue Processing";
  if (!carrierInvoiceApproved(state)) {
    return /* @__PURE__ */ jsx(
      "button",
      {
        className: "button--progress",
        onClick: () => addDocumentsToInvoiceAndGoToIndexer(props, state),
        children: buttonText
      }
    );
  }
}
function loadInstructions(props, state) {
  var message = state.newDocumentBatch ? "process the new documents to continue." : "respond to the email or continue processing.";
  var baseMessage = "Review the email and the information for this load.";
  if (carrierInvoiceApproved(state)) {
    return /* @__PURE__ */ jsxs("div", { className: "alert-box--highlight", children: [
      baseMessage,
      "\xA0 The invoice associated with this message has been approved. You can close the email or\xA0",
      /* @__PURE__ */ jsx("a", { onClick: () => goToIndexer(props, state), children: "view original documents" }),
      ". If you wish to continue the conversation, please use external email."
    ] });
  } else {
    return /* @__PURE__ */ jsxs("div", { className: "alert-box--progress", children: [
      baseMessage,
      "\xA0 When done, you can ",
      message
    ] });
  }
}
class ReplyView extends React.Component {
  constructor() {
    super(...arguments);
    // LIFECYCLE
    __publicField(this, "state", { loading: true });
    // STATE
    __publicField(this, "pageSelected", () => {
      this.forceUpdate();
    });
    __publicField(this, "typeUpdated", () => {
      this.forceUpdate();
    });
    __publicField(this, "loadFactorInvoice", (factorInvoiceId) => {
      FactorInvoicesService.getWithId(factorInvoiceId).then((factorInvoice) => {
        this.setState({ factorInvoice });
      });
    });
    __publicField(this, "loadLoadInformation", (loadStateId) => {
      var component = this;
      return LoadsService.forceGetLoad(loadStateId).then(function(load) {
        component.setState({ load });
        return DocumentsService.getDocumentBatches(load.document_batch_ids).then(
          function(batches) {
            var loadModel = new GroupedDocumentBrowserModel(
              DocumentBatchGroupCreator(batches, function(doc) {
                return _.first(doc.data.load_state_ids) === load.id;
              })
            );
            component.setState({ loadModel });
          }
        );
      });
    });
    __publicField(this, "loadOriginalDocumentBatch", (email) => {
      var component = this;
      const exceptionedItem = exceptionedItems(this.state)[0];
      if (exceptionedItem && exceptionedItem.owner_type === "DocumentGroup" && exceptionedItem.completed_at !== void 0) {
        return $.get("/api/document_groups/" + exceptionedItem.owner_id).then(
          (data) => {
            component.setState({
              originalDocumentGroupId: data.document_group.id,
              originalDocumentBatchId: data.document_group.document_batch_id
            });
          }
        );
      }
    });
    __publicField(this, "loadStateIdFromEmail", (email) => {
      if (email.load_states.length > 0) {
        return email.load_states[0].id;
      }
      if (email.parent) {
        return this.loadStateIdFromEmail(email.parent);
      }
    });
    __publicField(this, "loadNewDocuments", (batchId) => {
      var component = this;
      return DocumentsService.getDocumentBatch(batchId).then((batch) => {
        var newDocumentsModel = new GroupedDocumentBrowserModel(
          GroupIDGroupCreator(batch.documents, batch.document_groups),
          _.property("type")
        );
        var documentIndexerService = new DocumentIndexerService(
          batch,
          DataStoreService,
          Api.Account,
          this.props.location
        );
        component.setState({
          newDocumentBatch: batch,
          newDocumentsModel,
          documentIndexerService
        });
      });
    });
    __publicField(this, "forwardingCanceled", () => {
      this.setState({ forwardingEmail: false });
    });
    __publicField(this, "forwardingDone", (completed) => {
      this.forwardingCanceled();
      if (completed) {
        ToDashboardWithFilters(this.props.location);
      }
    });
    __publicField(this, "forwardEmail", () => {
      this.setState({ forwardingEmail: true });
    });
    __publicField(this, "possibleEmailForwarder", (email) => {
      if (this.state.forwardingEmail) {
        return /* @__PURE__ */ jsx(
          EmailForwarder,
          {
            email,
            onCancel: this.forwardingCanceled,
            onDone: this.forwardingDone
          }
        );
      }
    });
    __publicField(this, "startMarkingComplete", () => {
      this.setState({ markingComplete: true });
    });
    __publicField(this, "cancelMarkingComplete", () => {
      this.setState({ markingComplete: false });
    });
    __publicField(this, "content", () => {
      if (this.state.email) {
        return /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx("div", { className: "document-indexer__header", children: /* @__PURE__ */ jsx(
            IndexerHeader,
            {
              email: this.state.email,
              canMarkComplete: !hasDocuments(this.state),
              markComplete: this.startMarkingComplete,
              actions: this.actions(),
              load: this.state.load ? this.state.load.load : null
            }
          ) }),
          /* @__PURE__ */ jsx("div", { className: "reply-view__main-body row", children: /* @__PURE__ */ jsx("div", { className: "small-10 column reply-view__main-areas", children: /* @__PURE__ */ jsxs("div", { className: "row", children: [
            /* @__PURE__ */ jsx("div", { className: "small-5 column reply-view__work-area", children: this.documentAreaOrLoadArea() }),
            /* @__PURE__ */ jsx("div", { className: "small-5 column reply-view__documents-area", children: this.emailOrDocuments() })
          ] }) }) }),
          /* @__PURE__ */ jsx("div", { id: "presence", children: /* @__PURE__ */ jsx(
            PresenceList,
            {
              location: this.props.location,
              emailId: this.state.email.id
            }
          ) })
        ] });
      }
    });
    __publicField(this, "actions", () => {
      const actions = [["Forward Email", this.forwardEmail]];
      const location = this.props.location;
      if (Api.Account.indexAuditSplitEnabled() && isAuditMode(location) && isInNewFlowMode(location.query.onDone)) {
        actions.push([
          "Next Item",
          () => skipReply(this.props, this.state),
          "next-control"
        ]);
      }
      return actions;
    });
    __publicField(this, "documentAreaOrLoadArea", () => {
      if (this.state.load && !this.state.sendingEmail) {
        return this.loadInfoOrIdentifier();
      } else {
        return /* @__PURE__ */ jsxs("div", { children: [
          this.possibleEmailInformation(),
          this.possibleReplyEmailForm()
        ] });
      }
    });
    __publicField(this, "loadInfoOrIdentifier", () => {
      return /* @__PURE__ */ jsx("div", { children: this.loadInformation() });
    });
    __publicField(this, "loadInformation", () => {
      if (this.state.load) {
        return /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsxs("div", { className: "reply__email-information", children: [
            loadInstructions(this.props, this.state),
            loadContinueLink(this.props, this.state),
            possibleCloseReplyLink(this.props, this.state),
            this.sendEmailLink()
          ] }),
          /* @__PURE__ */ jsx(
            DocumentInformation,
            {
              model: this.state.loadModel,
              load: this.state.load,
              readOnly: true,
              carrierInvoice: carrierInvoice(this.state),
              carrier: carrier(this.state),
              keyPressNotifier: function(field) {
              },
              showNoteFieldByDefault: false,
              source_invoice_number: carrierInvoice(this.state).source_invoice_number,
              source_invoice_date: carrierInvoice(this.state).source_invoice_date,
              source_invoice_amount: carrierInvoice(this.state).source_invoice_amount
            }
          ),
          /* @__PURE__ */ jsx(
            PaymentInformation,
            {
              load: this.state.load,
              carrier: carrier(this.state),
              canSaveAndMarkAsProcessed: false,
              readOnly: true,
              keyPressNotifier: function(field) {
              },
              payment: payment(this.state),
              carrierInvoice: carrierInvoice(this.state),
              canEditAddress: false
            }
          ),
          /* @__PURE__ */ jsx(
            LoadDetailInformation,
            {
              model: this.state.loadModel,
              load: this.state.load,
              invoice: carrierInvoice(this.state)
            }
          )
        ] });
      }
    });
    // Likely dead code
    /* eslint-disable no-undef */
    __publicField(this, "documentModel", () => {
      return new GroupedDocumentBrowserModel(
        // @ts-expect-error
        DocumentBatchGroupCreator(documentBatches, function(doc) {
          return doc.carrier_invoice_id === invoiceID;
        })
      );
    });
    /* eslint-enable no-undef */
    __publicField(this, "emailOrDocuments", () => {
      return /* @__PURE__ */ jsx(
        DocumentBrowser,
        {
          initialSelectedComponent: initialSelectedComponent(this.state),
          model: this.documentModel,
          additionalComponents: additionalBrowserComponents(this.state)
        }
      );
    });
    __publicField(this, "possibleEmailInformation", () => {
      if (!this.state.sendingEmail) {
        return /* @__PURE__ */ jsxs("div", { className: "reply__email-information", children: [
          emailInstructions(this.state),
          /* @__PURE__ */ jsxs("div", { className: "reply__buttons", children: [
            possibleProcessFactorInvoiceButton(this.props, this.state),
            possibleProcessNewDocumentsButton(this.props, this.state),
            processOriginalButton(this.props, this.state),
            this.sendEmailLink()
          ] })
        ] });
      }
    });
    __publicField(this, "possibleReplyEmailForm", () => {
      if (emailChainWithoutDocuments(this.state) || this.state.sendingEmail) {
        return /* @__PURE__ */ jsx(
          ExceptionSender,
          {
            onComplete: () => onComplete(this.props),
            defaultEmail: {
              body: quotedBody(this.state.email),
              subject: "Re: " + this.state.email.subject
            },
            markParentComplete: true,
            emailMessageId: this.state.email.id,
            exceptionedItemId: exceptionedItems(this.state)[0] && exceptionedItems(this.state)[0].id,
            parent: this.state.email,
            canCancel: true,
            possibleLoad: this.state.load,
            cancel: this.cancelSendingEmail
          }
        );
      }
    });
    __publicField(this, "startSendingEmail", () => {
      this.setState({ sendingEmail: true });
    });
    __publicField(this, "cancelSendingEmail", () => {
      this.setState({ sendingEmail: false });
    });
    __publicField(this, "sendEmailLink", () => {
      if (!hasDocuments(this.state) && !carrierInvoiceApproved(this.state)) {
        return /* @__PURE__ */ jsx(
          "button",
          {
            className: "button--progress reply-view__send-email-button",
            onClick: this.startSendingEmail,
            children: "Reply To Email"
          }
        );
      }
    });
    __publicField(this, "possibleMarkComplete", (email) => {
      if (this.state.markingComplete) {
        return /* @__PURE__ */ jsx(
          MarkEmailCompleteView,
          {
            email,
            onCancel: this.cancelMarkingComplete,
            onMarkCompleteFinished: () => doneMarkingComplete(this.props)
          }
        );
      }
    });
  }
  componentDidMount() {
    var id = _.last(this.props.location.pathname.split("/")), component = this;
    emailService.getWithId(id, true).then(function(email) {
      component.setState({ email });
      var loadStateId = component.loadStateIdFromEmail(email), loadPromise;
      const exceptions = _.where(
        _.flatten(
          _.map(email.parent_emails, (email2) => {
            return email2.exceptioned_items;
          })
        ),
        { owner_type: "FactorInvoice" }
      );
      const exception = exceptions && exceptions[0];
      if (loadStateId) {
        loadPromise = component.loadLoadInformation(loadStateId);
      } else if (exception && exception.owner_type == "FactorInvoice") {
        loadPromise = component.loadFactorInvoice(exception.owner_id);
      } else {
        loadPromise = component.loadOriginalDocumentBatch(email);
      }
      var batch = email.document_batch;
      var newDocs = batch ? component.loadNewDocuments(batch.id) : true;
      Promise.all([loadPromise, newDocs]).then(function() {
        component.setState({ loading: false });
      });
    });
    maybePrefetchNextFlowModeItem(this.props.location);
  }
  // RENDER
  render() {
    return /* @__PURE__ */ jsx(
      Blocker,
      {
        "data-component": "ReplyView",
        modalView: this.possibleEmailForwarder(this.state.email) || this.possibleMarkComplete(this.state.email),
        children: /* @__PURE__ */ jsx("div", { className: "reply-view__container", children: /* @__PURE__ */ jsx(WaitingSpinner, { when: this.state.loading, children: /* @__PURE__ */ jsx("div", { className: "row general-container reply-container", children: this.content() }) }) })
      }
    );
  }
}
export default ReplyView;
